import React from 'react';
import PropTypes from 'prop-types';

import CollapsiblePanelContainer from './../Containers/CollapsiblePanelContainer';
import ArtifactHealthApplicationsComponent
  from './../Containers/ArtifactHealthApplicationsContainer';
import AddCommentModalContainer from './../Containers/AddCommentModalContainer';
import ShowCommentsModalContainer from './../Containers/ShowCommentsModalContainer';
import { annotation } from './../helpers';
import { annotations as annotationActions } from './../actions';

const ArtifactHealthPlatformComponent = ({ platform, annotations }) => (
  <div>
    <AddCommentModalContainer
      addCommentAction={annotationActions.addAppComment}
      statusList={annotation.getScenarioStatusList()}
      ticketOverridesStatus
      ticketStatusFunc={(t) => t ? 'Ticket Filed' : null}
    />
    <ShowCommentsModalContainer
      glyphFunc={(a) => annotation.getAnnotationGlyph(a)}
      removeCommentAction={annotationActions.removeAppComment}
      annotations={annotations}
    />
    <CollapsiblePanelContainer title={platform} minimal>
      <ArtifactHealthApplicationsComponent platform={platform} />
    </CollapsiblePanelContainer>
  </div>
);

ArtifactHealthPlatformComponent.propTypes = {
  platform: PropTypes.string.isRequired,
  annotations: PropTypes.object.isRequired
};

export default ArtifactHealthPlatformComponent;


// WEBPACK FOOTER //
// src/Components/ArtifactHealthPlatformComponent.jsx